<template>
    <div class="big-btn">
        <el-row>
            <div class="icon-position">
                <i :class="iconBtn"></i>
            </div>
        </el-row>
        <el-row>
            <div>
                <p>{{ msg | upper }}</p>
            </div>
        </el-row>
    </div>
</template>

<script>
  export default {
    props: {
        msg: {
            type: String,
            default: 'LINK'
        },
        iconBtn: {
            type: String,
            default: 'el-icon-document-copy'
        }
    },
    data() {
      return {
        
      }
    }
  }
</script>

<style scoped>
  p {
    text-align: center;
  }

  .big-btn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: space-between;
    border: 1px solid lightgray;
    border-radius: 4px;
    min-width: 200px;
    min-height: 200px;
    opacity: 0.6;
  }
  
  .big-btn:hover {
      opacity: 1;
      cursor: pointer;
      color: lightblue;
      border: 1px solid lightblue;
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  }

  .icon-position {
    font-size: 100px;
    display: flex;
    justify-content: center;
  }
</style>
